<template>
<div>
    <Breadcrumbs main="CRM" title="Lead Details" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>
        <div class="row">
            <div class="col-lg-9">
                <div class="h-100" style="display: flex; flex-direction: column; gap: 20px;  background-color: #FFFFFF; border-radius: 0.75rem; filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06)); padding: 32px;">
                    <div style="margin-top: 15px; display: flex; flex-direction: column;">
                        <h5>{{ details.first_name }} {{ details.last_name }}</h5>
                        <h7>{{ details?.company?.name }} <span v-if="details?.role" class="mx-2">|</span>{{ details?.role }}</h7>
                        <h7>Email: {{ details.email }}</h7>
                        <h7>Phone: {{ details.phone }}</h7>
                        <h7><span>Trigger:</span><span class="text-dark ml-1">{{ details.trigger_event }}</span></h7>
                    </div>
                    <div class="d-flex flex-wrap" style="gap:8px">
                        <div v-for="(stage, index) in stage_list" :key="stage.value" class="stage-box" :class="{
                            active: index <= currentStageIndex,
                            inactive: index > currentStageIndex
                        }" @click="changeStage(stage, index)">
                            <div class="stage-number">{{ index + 1 }}</div>
                            <div>{{ stage.text }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="h-100" style="display: flex; flex-direction: column; gap: 20px;  background-color: #FFFFFF; border-radius: 0.75rem; filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06)); padding: 24px;">
                    <h6>Status Control</h6>
                    <div class="d-flex flex-wrap" style="gap: 8px;">
                        <div class="" v-for="status,index in status_list" :key="index">
                            <div class="stage-box" @click="handleStatus(status.value)" :class="{
                                active_status: status.value === details.status,
                            }">
                                <p>{{ status.text }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-4 g-3">
            <div class="col-md-9">
                <div class="card">
                    <div class="card-body">
                        <div style="display: flex; flex-direction: row; gap: 20px; cursor: pointer;">
                            <h7 @click="toggleItem('overview')" :class="{ active: activeItem === 'overview' }">Overview</h7>
                            <h7 @click="toggleItem('call')" :class="{ active: activeItem === 'call' }">Call</h7>
                            <h7 @click="toggleItem('email')" :class="{ active: activeItem === 'email' }">Email</h7>
                            <h7 @click="toggleItem('message')" :class="{ active: activeItem === 'message' }">Message</h7>
                            <h7 @click="toggleItem('meeting')" :class="{ active: activeItem === 'meeting' }">Meeting</h7>
                            <h7 @click="toggleItem('history')" :class="{ active: activeItem === 'history' }">History</h7>
                            <h7 @click="toggleItem('notes')" :class="{ active: activeItem === 'notes' }">Notes</h7>
                            <h7 @click="toggleItem('files')" :class="{ active: activeItem === 'files' }">Files</h7>
                        </div>
                    </div>

                    <div class="card" v-if="activeItem === 'overview'">
                        <div class="card-body">
                            <div style="display: flex; flex-direction: column; margin-bottom: 20px; border: 1px solid #bedbff; border-radius: 0.75rem; padding: 20px; background-color: #eff6ff;">
                                <h5>Add Activity Log</h5>
                                <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 10px;">
                                    <b-form-input placeholder="Label" v-model="activity.label" style="max-width: 320px;"></b-form-input>
                                    <b-form-datepicker v-model="followupDate" style="max-width: 320px;"></b-form-datepicker>
                                    <b-form-timepicker v-model="followupTime" style="max-width: 320px;"></b-form-timepicker>
                                    <b-form-select v-model="activity.outcome" placeholder="Outcome" :options="[ { value: null, text: 'Outcome', disabled: true }, { value: 'connected', text: 'Connected' }, { value: 'no_answer', text: 'No Answer' }, { value: 'positive', text: 'Positive' }, { value: 'negative', text: 'Negative' }, { value: 'info_sent', text: 'Info Sent' }, { value: 'rescheduled', text: 'Rescheduled' }, { value: 'other', text: 'Other' }]" :class="{ 'placeholder-select': activity.outcome === null }" style="max-width: 320px;"></b-form-select>
                                    <b-form-input placeholder="Next action" v-model="activity.next_action" style="max-width: 320px;"></b-form-input>
                                    <b-form-input placeholder="Note" v-model="activity.notes" style="max-width: 320px;"></b-form-input>
                                    <b-button variant="primary" style="max-width: 320px;" @click="saveActivityLog">Save Log</b-button>
                                </div>
                            </div>

                            <div class="row" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 20px;">
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Lead Name</h7>
                                    <p style="font-weight: bold;">{{ (details.first_name || details.last_name) ? ((details.first_name || '') + ' ' + (details.last_name || '')).trim() : 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Company</h7>
                                    <p style="font-weight: bold;">{{ details.company?.name || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Designation</h7>
                                    <p style="font-weight: bold;">{{ details.role || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Phone</h7>
                                    <p style="font-weight: bold;">{{ details.phone || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Email</h7>
                                    <p style="font-weight: bold;">{{ details.email || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Address</h7>
                                    <p style="font-weight: bold;">{{ details.address || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Source</h7>
                                    <p style="font-weight: bold;">{{ details.source || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Trigger Event</h7>
                                    <p style="font-weight: bold;">{{ details.trigger_event || 'N/A' }}</p>
                                </div>
                                <!-- <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Product Interest</h7>
                                    <p style="font-weight: bold;">{{ details.product_interest }}</p>
                                </div> -->
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Pipeline Value</h7>
                                    <p style="font-weight: bold;">{{ details.pipeline_value || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Assigned Manager</h7>
                                    <p style="font-weight: bold;">{{ details.owner?.full_name || 'N/A' }}</p>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #f1f5f9; border-radius: 0.75rem; padding: 20px; background-color: #f8fafc;">
                                    <h7 style="color: #90a1b9;">Next Follow-up</h7>
                                    <p style="font-weight: bold;">{{ details.next_followup ? formatDateTime(details.next_followup) : 'N/A' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card" v-if="activeItem === 'call'">
                        <div class="card-body">
                            <div style="display: flex; flex-direction: column; margin-bottom: 20px; border: 1px solid #bedbff; border-radius: 0.75rem; padding: 20px; background-color: #eff6ff;">
                                <h5>Add Activity Log</h5>
                                <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 10px;">
                                    <b-form-datepicker v-model="followupDate" style="max-width: 320px;"></b-form-datepicker>
                                    <b-form-timepicker v-model="followupTime" style="max-width: 320px;"></b-form-timepicker>
                                    <b-form-select v-model="activity.outcome" placeholder="Outcome" :options="[ { value: null, text: 'Outcome', disabled: true }, { value: 'connected', text: 'Connected' }, { value: 'no_answer', text: 'No Answer' }, { value: 'positive', text: 'Positive' }, { value: 'negative', text: 'Negative' }, { value: 'info_sent', text: 'Info Sent' }, { value: 'rescheduled', text: 'Rescheduled' }, { value: 'other', text: 'Other' }]" :class="{ 'placeholder-select': activity.outcome === null }" style="max-width: 320px;"></b-form-select>
                                    <b-form-input placeholder="Next action" v-model="activity.next_action" style="max-width: 320px;"></b-form-input>
                                    <b-form-input placeholder="Note" v-model="activity.notes" style="max-width: 320px;"></b-form-input>
                                    <b-button variant="primary" style="max-width: 320px;" @click="saveActivityLog">Save Log</b-button>
                                </div>
                            </div>

                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="lead_activities" :fields="tablefieldsCall" :filter="filter" :current-page="currentPage" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(date)="data">
                                        <h7 v-if=" data.item.date"> {{ formatDateTime(data.item.date) }}</h7>
                                    </template>
                                </b-table>
                            </div>

                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>

                    <div class="card" v-if="activeItem === 'message'">
                        <div class="card-body">
                            <div style="display: flex; flex-direction: column; margin-bottom: 20px; border: 1px solid #bedbff; border-radius: 0.75rem; padding: 20px; background-color: #eff6ff;">
                                <h5>Add Activity Log</h5>
                                <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 10px;">
                                    <b-form-datepicker v-model="followupDate" style="max-width: 320px;"></b-form-datepicker>
                                    <b-form-timepicker v-model="followupTime" style="max-width: 320px;"></b-form-timepicker>
                                    <b-form-select v-model="activity.metadata.channel" placeholder="Channel" :options="[ { value: null, text: 'Channel', disabled: true }, { value: 'WhatsApp', text: 'WhatsApp' }, { value: 'SMS', text: 'SMS' }, { value: 'LinkedIn', text: 'LinkedIn' }, { value: 'Facebook', text: 'Facebook' }]" :class="{ 'placeholder-select': activity.outcome === null }" style="max-width: 320px;"></b-form-select>
                                    <b-form-select v-model="activity.outcome" placeholder="Outcome" :options="[ { value: null, text: 'Outcome', disabled: true }, { value: 'connected', text: 'Connected' }, { value: 'no_answer', text: 'No Answer' }, { value: 'positive', text: 'Positive' }, { value: 'negative', text: 'Negative' }, { value: 'info_sent', text: 'Info Sent' }, { value: 'rescheduled', text: 'Rescheduled' }, { value: 'other', text: 'Other' }]" :class="{ 'placeholder-select': activity.outcome === null }" style="max-width: 320px;"></b-form-select>
                                    <b-form-input placeholder="Next action" v-model="activity.next_action" style="max-width: 320px;"></b-form-input>
                                    <b-form-input placeholder="Note" v-model="activity.notes" style="max-width: 320px;"></b-form-input>
                                    <b-button variant="primary" style="max-width: 320px;" @click="saveActivityLog">Save Log</b-button>
                                </div>
                            </div>

                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="lead_activities" :fields="tablefieldsMessage" :filter="filter" :current-page="currentPage" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(date)="data">
                                        <h7 v-if=" data.item.date"> {{ formatDateTime(data.item.date) }}</h7>
                                    </template>
                                </b-table>
                            </div>

                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>

                    <div class="card" v-if="activeItem === 'email'">
                        <div class="card-body">
                            <div style="display: flex; flex-direction: column; margin-bottom: 20px; border: 1px solid #bedbff; border-radius: 0.75rem; padding: 20px; background-color: #eff6ff;">
                                <h5>Add Activity Log</h5>
                                <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 10px;">
                                    <b-form-datepicker v-model="followupDate" style="max-width: 320px;"></b-form-datepicker>
                                    <b-form-timepicker v-model="followupTime" style="max-width: 320px;"></b-form-timepicker>
                                    <b-form-select v-model="activity.outcome" placeholder="Outcome" :options="[ { value: null, text: 'Outcome', disabled: true }, { value: 'connected', text: 'Connected' }, { value: 'no_answer', text: 'No Answer' }, { value: 'positive', text: 'Positive' }, { value: 'negative', text: 'Negative' }, { value: 'info_sent', text: 'Info Sent' }, { value: 'rescheduled', text: 'Rescheduled' }, { value: 'other', text: 'Other' }]" :class="{ 'placeholder-select': activity.outcome === null }" style="max-width: 320px;"></b-form-select>
                                    <b-form-input placeholder="Subject" v-model="activity.metadata.subject" style="max-width: 320px;"></b-form-input>
                                    <b-form-input placeholder="Note" v-model="activity.notes" style="max-width: 320px;"></b-form-input>
                                    <b-button variant="primary" style="max-width: 320px;" @click="saveActivityLog">Save Log</b-button>
                                </div>
                            </div>

                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="lead_activities" :fields="tablefieldsEmail" :filter="filter" :current-page="currentPage" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(date)="data">
                                        <h7 v-if=" data.item.date"> {{ formatDateTime(data.item.date) }}</h7>
                                    </template>
                                </b-table>
                            </div>

                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>

                    <div class="card" v-if="activeItem === 'meeting'">
                        <div class="card-body">
                            <div style="display: flex; flex-direction: column; margin-bottom: 20px; border: 1px solid #bedbff; border-radius: 0.75rem; padding: 20px; background-color: #eff6ff;">
                                <h5>Add Activity Log</h5>
                                <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 10px;">
                                    <b-form-datepicker v-model="followupDate" style="max-width: 320px;"></b-form-datepicker>
                                    <b-form-timepicker v-model="followupTime" style="max-width: 320px;"></b-form-timepicker>
                                    <b-form-input placeholder="Title" v-model="activity.metadata.title" style="max-width: 320px;"></b-form-input>
                                    <multiselect v-model="activity.participants" tag-placeholder="Add participants" placeholder="Search or add a participant" label="first_name" :max="user_list.length" track-by="id" :options="user_list" :multiple="true" :taggable="true" style="max-width: 660px;"></multiselect>
                                    <b-form-select v-model="activity.outcome" placeholder="Outcome" :options="[ { value: null, text: 'Outcome', disabled: true }, { value: 'connected', text: 'Connected' }, { value: 'no_answer', text: 'No Answer' }, { value: 'positive', text: 'Positive' }, { value: 'negative', text: 'Negative' }, { value: 'info_sent', text: 'Info Sent' }, { value: 'rescheduled', text: 'Rescheduled' }, { value: 'other', text: 'Other' }]" :class="{ 'placeholder-select': activity.outcome === null }" style="max-width: 320px;"></b-form-select>
                                    <b-form-input placeholder="Note" v-model="activity.notes" style="max-width: 320px;"></b-form-input>
                                    <b-form-input placeholder="Next action" v-model="activity.next_action" style="max-width: 320px;"></b-form-input>
                                    <b-button variant="primary" style="max-width: 320px;" @click="saveActivityLog">Save Log</b-button>
                                </div>
                            </div>

                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="lead_activities" :fields="tablefieldsMeeting" :filter="filter" :current-page="currentPage" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(date)="data">
                                        <h7 v-if=" data.item.date"> {{ formatDateTime(data.item.date) }}</h7>
                                    </template>
                                </b-table>
                            </div>

                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>

                    <div class="" v-if="activeItem === 'history'">
                        <div style="padding: 32px;">
                            <div class="d-flex flex-column" style="gap: 16px;">
                                <div v-for="activity, index in lead_activities" :key="index">
                                    <div style="background-color: #F8FAFC; padding: 24px 38px; border-radius: 8px;" class="d-flex flex-column">
                                        <div style="display: flex; flex-direction: column; gap: 8px;">
                                            <h6 style="text-transform: uppercase;">{{ activity.type === 'other' && activity.label !== null ? activity.label : activity.type }}</h6>
                                            <h7>Note: {{ activity.note ? activity.note : 'N/A' }}</h7>
                                            <h7>Next Action: {{ activity.next_action ? activity.next_action : 'N/A' }}</h7>
                                           <div class="mt-2 d-flex">
                                                <small v-if="activity.date">{{ formatDateTime(activity.date) }}</small>
                                                <small v-if="activity.created_by_name" class="ml-3">Created by: {{ activity.created_by_name }}</small>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="" v-if="activeItem === 'notes'">
                        <div style="padding: 32px;">
                            <div class="d-flex justify-content-end mb-4">
                                <button class="btn btn-primary" v-b-modal.note_create_modal>Create Note</button>
                            </div>
                            <div class="d-flex flex-column" style="gap: 16px;">
                                <div v-for="note,index in notes" :key="index">
                                    <div style="background-color: #F8FAFC; padding: 24px 38px; border-radius: 8px;" class="d-flex flex-column">
                                        <div>
                                            <h6>{{ note.title }}</h6>
                                            <p>{{ note.body }}</p>
                                            <small class="mt-2">{{ formatDateTime(note.created_at) }}</small>
                                        </div>
                                        <div class="d-flex flex-row mt-2" style="gap: 8px;">
                                            <div>
                                                <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-note-delete @click="deleteNote(note.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editNote(note)">
                                                <feather type="edit" size="18px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.note_edit_modal></feather>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="" v-if="activeItem === 'files'">
                        <div style="padding: 32px;">
                            <div class="d-flex justify-content-end mb-4">
                                <button class="btn btn-primary" v-b-modal.modal-scrollable-add-document>Add</button>
                            </div>
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="attachments" :fields="tablefieldsAttchments" :filter="filter" :current-page="currentPage" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(label)="data">
                                         <div class="d-flex flex-column">
                                             <a :href="host + data.item.file" target="_blank" rel="noopener noreferrer">
                                            {{ data.item.label }}
                                          </a>
                                          <small>{{ formatDateTime(data.item.uploaded_at) }}</small>
                                         </div>
                                    </template>

                                    <template #cell(action)="data">
                                          <div>
                                            <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-attachment-delete @click="deleteAttachment(data.item.id)" title="Delete"></feather>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 ">
                <div class="" style="display: flex; flex-direction: column; gap: 20px;  background-color: #FFFFFF; border-radius: 0.75rem; filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06)); padding: 24px; overflow-y: scroll; max-height: 80dvh;">
                    <div>
                        <div class="d-flex justify-content-between mb-4 align-items-center">
                            <h7>Next Actions</h7>
                            <button class="btn btn-primary" v-b-modal.action_create_modal>Add</button>
                        </div>
                        <div class="d-flex flex-column" style="gap: 16px;">
                            <div v-for="act,index in actions" :key="index">
                                <div style="background-color: #F8FAFC; padding: 24px 38px; border-radius: 8px; gap: 8px;">
                                    <div class="d-flex flex-column">
                                        <small class="priority-badge mb-2" :class="{
                                            'priority-high': act.priority === 'high',
                                            'priority-medium': act.priority === 'medium',
                                            'priority-low': act.priority === 'low'
                                        }">
                                            {{ act.priority }}
                                        </small>
                                        <h6>{{ act.task }}</h6>
                                        <small>{{ act.due_date }}</small>
                                    </div>
                                    <div class="d-flex flex-row mt-2" style="gap: 8px;">
                                        <div>
                                            <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-action-delete @click="deleteAction(act.id)" title="Delete"></feather>
                                        </div>

                                        <div @click="editAction(act)">
                                            <feather type="edit" size="18px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.action_edit_modal></feather>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Note Create -->
    <b-modal id="note_create_modal" ref="modal" title="Create Note" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <b-form-group label="Title" label-for="name-input">
                <b-form-input v-model="note.title" placeholder="Enter note title"></b-form-input>
            </b-form-group>
            <b-form-group label="Notice" label-for="textarea-rows">
                <b-form-textarea id="textarea-rows" placeholder="Note description..." rows="5" v-model="note.body"></b-form-textarea>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Note Edit -->
    <b-modal id="note_edit_modal" ref="modal" title="Update Note" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit()">
            <b-form-group label="Title" label-for="name-input">
                <b-form-input v-model="edit_note.title" placeholder="Enter note title"></b-form-input>
            </b-form-group>

            <b-form-group label="Notice" label-for="textarea-rows">
                <b-form-textarea id="textarea-rows" placeholder="Note description..." rows="5" v-model="edit_note.body"></b-form-textarea>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Note Delete -->
    <b-modal id="modal-note-delete" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this note?</div>
    </b-modal>

    <!-- Next Action Create -->
    <b-modal id="action_create_modal" ref="modal" title="Create Next Action" @show="resetActionModal" @hidden="resetActionModal" @ok="handleActionOk">
        <form ref="form" @submit.stop.prevent="handleActionSubmit()">
            <b-form-group label="Title" label-for="name-input">
                <b-form-input v-model="action.task" placeholder="Enter task title"></b-form-input>
            </b-form-group>

            <b-form-group label="Priority" label-for="owner-name">
                <b-form-select id="owner-name" v-model="action.priority" :options="priority_list">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Priority
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <div class="form-group">
                <label>Due Date</label>
                <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" ref="datepicker" v-model="action.due_date"></datepicker>
            </div>
        </form>
    </b-modal>

    <!-- Edit Action -->
    <b-modal id="action_edit_modal" ref="modal" title="Edit Next Action" @show="resetEditActionModal" @hidden="resetEditActionModal" @ok="handleEditActionOk">
        <form ref="form" @submit.stop.prevent="handleEditActionSubmit()">
            <b-form-group label="Title" label-for="name-input">
                <b-form-input v-model="edit_action.task" placeholder="Enter task title"></b-form-input>
            </b-form-group>
            <b-form-group label="Priority" label-for="owner-name">
                <b-form-select id="owner-name" v-model="edit_action.priority" :options="priority_list">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Priority
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <div class="form-group">
                <label>Due Date</label>
                <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" ref="datepicker" v-model="edit_action.due_date"></datepicker>
            </div>
        </form>
    </b-modal>

    <!-- Action Delete -->
    <b-modal id="modal-action-delete" centered hide-header @ok="handleActionDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this action?</div>
    </b-modal>

    <!--  Attachment Create -->
    <b-modal id="modal-scrollable-add-document" ref="modal" title="Add document" @ok="handleAttachOk">
        <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Label</label>
                        <input class="form-control" type="text" placeholder="Enter Label ..." v-model="add_attachment.label">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload Documents</label>
                        <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Delete Attchment Modal -->
    <b-modal id="modal-attachment-delete" centered hide-header @ok="handleDeleteAttachment">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this document?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import img1 from "../../../assets/images/user/3.jpg";
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import { myHost } from '../../../_helpers/host';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Datepicker,
        Multiselect,
    },

    data() {
        return {
            host: myHost.host,
            activeItem: 'overview',
            activity: {
                type: this.activeItem,
                date: null,
                outcome: null,
                label: null,
                participants: [],
                next_action: '',
                notes: '',
                metadata: {
                    channel: null,
                    subject: null,
                    time: null,
                    title: null
                }
            },
            followupDate: moment().format('YYYY-MM-DD'),
            followupTime: '09:00:00',
            image: img1,
            tablefieldsCall: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true
                },
                {
                    key: 'created_by_name',
                    label: 'By',
                    sortable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    sortable: true
                },
                {
                    key: 'outcome',
                    label: 'Outcome',
                    sortable: true
                },
                {
                    key: 'notes',
                    label: 'Note',
                    sortable: true
                },
                {
                    key: 'next_action',
                    label: 'Next',
                    sortable: true
                }
            ],
            tablefieldsMessage: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true
                },
                {
                    key: 'metadata.channel',
                    label: 'Channel',
                    sortable: true
                },
                {
                    key: 'outcome',
                    label: 'Outcome',
                    sortable: true
                },
                {
                    key: 'notes',
                    label: 'Note',
                    sortable: true
                },
                {
                    key: 'next_action',
                    label: 'Next',
                    sortable: true
                },
            ],
            tablefieldsEmail: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true
                },
                {
                    key: 'metadata.subject',
                    label: 'Subject',
                    sortable: true
                },
                {
                    key: 'outcome',
                    label: 'Outcome',
                    sortable: true
                },
                {
                    key: 'notes',
                    label: 'Note',
                    sortable: true
                },
            ],
            tablefieldsMeeting: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true
                },
                {
                    key: 'metadata.title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'participants',
                    label: 'Participants',
                    sortable: true
                },
                {
                    key: 'outcome',
                    label: 'Outcome',
                    sortable: true
                },
                {
                    key: 'notes',
                    label: 'Note',
                    sortable: true
                },
                {
                    key: 'next_action',
                    label: 'Next',
                    sortable: true
                },
            ],
            tablefieldsAttchments: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'label',
                    label: 'Label',
                    sortable: true
                },
                
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                },

            ],
            status_list: [{
                    value: 'open',
                    text: 'Open'
                },
                {
                    value: 'active',
                    text: 'Active'
                },
                {
                    value: 'hold',
                    text: 'Hold'
                },
                {
                    value: 'lost',
                    text: 'Lost'
                },
                {
                    value: 'rejected',
                    text: 'Rejected'
                },
                {
                    value: 'converted',
                    text: 'Converted'
                }
            ],

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            stage_list: [{
                    value: 'suspect',
                    text: 'Suspect'
                },
                {
                    value: 'qualified',
                    text: 'Qualified'
                },
                {
                    value: 'discovery',
                    text: 'Discovery'
                },
                {
                    value: 'demo',
                    text: 'Demo'
                },
                {
                    value: 'proposal',
                    text: 'Proposal'
                },
                {
                    value: 'trial',
                    text: 'Trial'
                },
                {
                    value: 'customer',
                    text: 'Customer'
                }
            ],
            note: {
                title: '',
                body: ''
            },
            edit_note: {
                id: '',
                title: '',
                body: ''

            },
            action: {
                task: '',
                due_date: '',
                priority: null,
            },
            edit_action: {
                id: null,
                task: '',
                due_date: '',
                priority: null,
            },
            selected_note: null,
            selected_action: null,
            attachment_selected: null,
            priority_list: [{
                    id: 1,
                    text: 'High',
                    value: 'high'
                },
                {
                    id: 2,
                    text: 'Medium',
                    value: 'medium'
                },
                {
                    id: 3,
                    text: 'Low',
                    value: 'low'
                }
            ],
            add_attachment: {
                file: null,
                label: '',
            }
        };
    },

    watch: {
        activeItem: {
            handler(newItem) {
                this.$store.dispatch("lead/viewLeadActivityByType", {
                    leadId: this.$route.params.id,
                    activityType: newItem === 'history' ? 'all' : newItem
                })
            },
            immediate: true
        },
        lead_activities: {
            handler(newActivities) {
                this.totalRows = newActivities.length;
            },
            immediate: true
        },
        followupDate() {
            this.updateDateTime()
        },
        followupTime() {
            this.updateDateTime()
        },

    },

    computed: {
        ...mapState({
            details: state => state.lead.lead_details,
            lead_activities: state => state.lead.lead_activities,
            user_list: state => state.employee.employee_list,
            notes: state => state.lead.lead_notes,
            actions: state => state.lead.lead_next_actions,
            attachments: state => state.lead.lead_attchments
        }),
        currentStageIndex() {
            return this.stage_list.findIndex(
                stage => stage.value === this.details.stage
            );
        }
    },

    mounted() {
        this.$store.dispatch("lead/fetchLeadDetails", this.$route.params.id)
        this.$store.dispatch("employee/fetchEmployeeList");
        this.$store.dispatch("lead/fetchLeadNotes", this.$route.params.id)
        this.$store.dispatch("lead/fetchLeadNextActions", this.$route.params.id)
        this.$store.dispatch("lead/fetchLeadAttachments", this.$route.params.id)
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },
        
        changeStage(stage, index) {
            // prevent moving back from the last stage to any previous stage
            const lastIndex = this.stage_list.length - 1;
            if (this.currentStageIndex === lastIndex && index < this.currentStageIndex) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Warning',
                    text: 'You can not move back to other stages from Customer stage.',
                });
                return;
            }

            this.$store.dispatch("lead/updateLeadStage", {
                id: this.$route.params.id,
                stage: stage.value
            }).then((response) => {
                if (response.code === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Stage changed successfully!',
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to change stage.'
                    })
                }
            })
        },

        toggleItem(item) {
            this.activeItem = item;
        },

        formatDateTime(date) {
            return new Date(date).toLocaleString('en-BD', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        },

        updateDateTime() {
            if (this.followupDate && this.followupTime) {
                this.activity.date = `${this.followupDate}T${this.followupTime}`
            }
        },

        saveActivityLog() {
            if(this.activeItem === 'overview') {
                this.activity.type = 'other';
            } else {
                this.activity.type = this.activeItem;
            }
            if (!this.activity.date) {
                this.followupDate = moment().format('YYYY-MM-DD')
                this.activity.date = `${this.followupDate}T${this.followupTime}`
            }
            const activityPayload = {
                ...this.activity
            };
            if (Array.isArray(activityPayload.participants) && activityPayload.participants.length > 0) {
                activityPayload.participants = activityPayload.participants
                    .map(participant => participant && typeof participant === 'object' ? participant.id : participant);
            } else {
                delete activityPayload.participants;
            }
            this.$store.dispatch("lead/addLeadActivity", {
                leadId: this.$route.params.id,
                activity: activityPayload
            }).then((response) => {
                if (response.code === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Activity log added successfully!',
                    });
                    this.activity = {
                        type: this.activeItem,
                        date: null,
                        outcome: null,
                        participants: [],
                        next_action: '',
                        notes: '',
                        metadata: {
                            channel: null,
                            subject: null,
                            time: null,
                            title: null
                        }
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to add activity log. Please try again.'
                    })
                }
            })
        },

        resetModal() {
            this.note = {
                title: '',
                body: ''
            }
        },
        reseEditModal() {
            this.edit_note = {
                id: null,
                title: '',
                body: ''
            }
        },
        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()

        },

        handleSubmit() {
            this.$store.dispatch("lead/addLeadNote", {
                lead_id: this.$route.params.id,
                lead_note: this.note
            }).then(response => {
                // console.log(this.holiday)
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('note_create_modal')
            })
        },
        editNote(data) {
            this.edit_note = {
                id: data.id,
                title: data.title,
                body: data.body
            }
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()

        },

        handleEditSubmit() {
            this.$store.dispatch("lead/updateLeadNote", {

                lead_id: this.$route.params.id,
                lead_note: this.edit_note
            }).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.reseEditModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('note_edit_modal')
            })
        },

        handleDeleteOk() {
            this.$store.dispatch("lead/deleteNote", {
                lead_id: this.$route.params.id,
                note_id: this.selected_note
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.selected_note = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-note-delete')
                })

            })
        },

        deleteNote(id) {
            this.selected_note = id
        },

        resetActionModal() {
            this.action = {
                task: '',
                due_date: '',
                priority: null,
            }
        },
        resetEditActionModal() {
            this.edit_action = {
                id: null,
                task: '',
                due_date: '',
                priority: null,
            }
        },
        handleActionOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleActionSubmit()

        },

        handleActionSubmit() {
            if (this.action.due_date !== null) {
                this.action.due_date = moment(String(this.action.due_date)).format("YYYY-MM-DD");
            }
            this.$store.dispatch("lead/addLeadAction", {

                lead_id: this.$route.params.id,
                lead_action: this.action
            }).then(response => {
                // console.log(this.holiday)
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetActionModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('action_create_modal')
            })
        },
        deleteAction(id) {
            this.selected_action = id
        },
        handleActionDeleteOk() {
            this.$store.dispatch("lead/deleteNextAction", {
                lead_id: this.$route.params.id,
                action_id: this.selected_action
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.selected_note = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-action-delete')
                })

            })
        },

        editAction(data) {
            this.edit_action = {
                id: data.id,
                task: data.task,
                due_date: data.due_date,
                priority: data.priority,
            }
        },

        handleEditActionOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditActionSubmit()

        },

        handleEditActionSubmit() {
            if (this.edit_action.due_date !== null) {
                this.edit_action.due_date = moment(String(this.edit_action.due_date)).format("YYYY-MM-DD");
            }
            this.$store.dispatch("lead/updateLeadNextAction", {

                lead_id: this.$route.params.id,
                lead_action: this.edit_action
            }).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditActionModal()

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('action_edit_modal')
            })
        },

        handleStatus(value) {
            this.$store.dispatch("lead/updateLeadStatus", {
                id: this.$route.params.id,
                status_for_change: value,
                from_details: true

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

        },
        uploadAttachFile(e) {
            this.add_attachment.file = e.target.files[0]
        },
        handleAttachOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleAttahmentSubmit()
        },

        handleAttahmentSubmit() {
            this.$store.dispatch("lead/addLeadAttachment", {
                attachment: this.add_attachment,
                lead_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.add_attachment = {
                        file: null,
                        label: '',
                    }

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable-add-document')
            })
        },
        deleteAttachment(id){
            this.attachment_selected = id
        },

        handleDeleteAttachment() {
            this.$store.dispatch("lead/deleteAttachmentLead", {
                attachment: this.attachment_selected,
                lead_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_id = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }

    }
}
</script>

<style scoped>
.active {
    color: #ff595d;
    font-weight: 600;
}

.stage-box {
    min-width: 120px;
    padding: 12px 18px;
    border-radius: 12px;
    cursor: pointer;
    border: 1px solid #d6dbe5;
    transition: all 0.3s;
}

.stage-box.active {
    color: black;
    border-color: #FFF0F0;
    background-color: rgba(255, 0, 6, 0.06);
    padding: 15px 17px;
    border-radius: 10px;
}

.stage-box.inactive {
    background: #f3f4f6;
    color: #94a3b8;
}

.stage-box.active_status {
    color: white;
    border-color: #000000;
    background-color: #000000;
}

.stage-number {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 4px;
}

.stage-box.inactive:hover {
    background: #e5e7eb;
}

.priority-badge {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    max-width: fit-content;
}

.priority-high {
    background: #fee2e2;
    color: #dc2626;
}

.priority-medium {
    background: #fef3c7;
    color: #d97706;
}

.priority-low {
    background: #dcfce7;
    color: #16a34a;
}
</style>
